export default "__VITE_ASSET__ClZas58j__"